import {until} from 'lit-html/directives/until';
import '@modules/dropdown';
import '@modules/select';
import {permissionGroupKeys, permissions} from '@modules/constants-enumerate';
import '../permission-check-mark';
import '@modules/show-modal';
import {nothing} from 'lit-html';
import {ThreeWayToggle} from '@modules/three-way-toggle';

export default (ctx, html) => html`
<div class="border-0 card card-full-info rounded text-body">
  ${ctx.loggedInUserId !== ctx['user-id'] && !ctx.isRootAdmin ? html`

      <button type="button" class="close text-body" aria-label="Close" @click="${ctx.discard}">
        <span aria-hidden="true"><span class="ai ai-close-icon"></span></span>
      </button>

  `: ''}

  <div class="card-body">
    <p>${ctx.role.breadcrumbs}</p>

    <div class="card border-0 rounded">
      <div class="card-body p-4">

      ${ctx.role.access_data[permissions.SPONSOR] ?
        until(ctx.__('<tt-xulm0qxe>', 'Sponsor Access')) :
        ctx.role.access_data[permissions.HIDE_STUDENT] ?
        until(ctx.__('<tt-aDyVJ7pK>', 'Hide Student')) :
        renderPermissions(ctx, html)}
    </div>
  </div>
</div>
`;

const renderPermissions = (ctx, html) => html`
<div class="row no-gutters">
  <div class="permission-col col-12 col-sm-4 col-lg-3 col-xl-2 text-center text-nowrap d-flex justify-content-between d-sm-block">
    <p class="permission-headers mb-2">${until(ctx.__('<tt-sYFvi1AE>', 'Administrator Accounts'))}</p>
    <permission-check-mark .state="${ctx.role.roles[permissionGroupKeys.ADMIN_ACCOUNTS]?.toggleState}"></permission-check-mark>
  </div>

  <div class="permission-col col-12 col-sm-4 col-lg-3 col-xl-2 text-center  d-flex justify-content-between d-sm-block">
    <p class="permission-headers mb-2">${until(ctx.__('<tt-qnH4Vvzj>', 'Manual Roster'))}</p>
    <permission-check-mark .state="${ctx.role.roles[permissionGroupKeys.MANUAL_ROSTER]?.toggleState}"></permission-check-mark>
    <ems-dropdown class="details-dropdown w-100 full-width" openOnSelect>
      <button slot="dropdown-toggle" class="btn btn-link p-0 text-left text-sm-center w-100 mt-n2">
        <span class="show-details mx-auto">${until(ctx.__('<tt-MZQnjWsj>', 'Show Details'))}</span>
        <span class="hide-details mx-auto">${until(ctx.__('<tt-JNJ/w8WO>', 'Hide Details'))}</span>
      </button>
      <div slot="dropdown-menu">
        <div slot="dropdown-menu" class="list-group p-0 w-100">
          <div class="list-group-item text-nowrap d-flex justify-content-between">
            <span class="mr-4">${until(ctx.__('<tt-aNreSj3y>', 'Teachers Create and Update'))}</span>
            ${ctx.role.access_data[permissions.TEACHER_EDIT]? html`<span class="check-mark"><span class="ai ai-checkmark text-primary"></span></span>`: ''}
          </div>

          <div class="list-group-item text-nowrap d-flex justify-content-between">
            <span class="mr-4">${until(ctx.__('<tt-3kYmXoyZ>', 'Students Create and Update'))}</span>
            ${ctx.role.access_data[permissions.STUDENT_EDIT]? html`<span class="check-mark"><span class="ai ai-checkmark text-primary"></span></span>`: ''}
          </div>

          <div class="list-group-item text-nowrap d-flex justify-content-between">
            <span class="mr-4">${until(ctx.__('<tt-NmI9N7Ui>', 'Groups Create and Update'))}</span>
            ${ctx.role.access_data[permissions.GROUP_EDIT]? html`<span class="check-mark"><span class="ai ai-checkmark text-primary"></span></span>`: ''}
          </div>

          <div class="list-group-item text-nowrap d-flex justify-content-between">
            <span class="mr-4">${until(ctx.__('<tt-NMfGtTCV>', 'Export All'))}</span>
            ${ctx.role.access_data[permissions.EXPORT_ALL]? html`<span class="check-mark"><span class="ai ai-checkmark text-primary"></span></span>`: ''}
          </div>
        </div>
      </div>
    </ems-dropdown>
  </div>

  <div class="permission-col col-12 col-sm-4 col-lg-3 col-xl-2 text-center text-nowrap d-flex justify-content-between d-sm-block">
    <p class="permission-headers mb-2">${until(ctx.__('<tt-Ytv0rXbe>', 'Upload Rosters'))}</p>
    <permission-check-mark .state="${ctx.role.roles[permissionGroupKeys.ROSTER_UPLOAD]?.toggleState}"></permission-check-mark>
  </div>

  ${ctx.settings.available_rostering_systems.sftp === true ? html`
    <div class="permission-col col-12 col-sm-4 col-lg-3 col-xl-2 text-center text-nowrap d-flex justify-content-between d-sm-block">
      <p class="permission-headers mb-2">${until(ctx.__('<tt-P+RZhA3F>', 'Manage SFTP'))}</p>
      <permission-check-mark .state="${ctx.role.roles[permissionGroupKeys.SFTP]?.toggleState}"></permission-check-mark>
    </div>`: nothing}

  <div class="permission-col col-12 col-sm-4 col-lg-3 col-xl-2 text-center text-nowrap d-flex justify-content-between d-sm-block">
    <p class="permission-headers mb-2">${until(ctx.__('<tt-vVU36MwN>', 'Licenses'))}</p>
    <permission-check-mark .state="${ctx.role.roles[permissionGroupKeys.LICENSE]?.toggleState}"></permission-check-mark>
  </div>

  <div class="permission-col col-12 col-sm-4 col-lg-3 col-xl-2 text-center text-nowrap d-flex justify-content-between d-sm-block">
    <p class="permission-headers mb-2">${until(ctx.__('<tt-umcwkRlB>', 'Reports'))}</p>
    <p class="permission-headers text-muted">${until(ctx.__('<tt-NmPRpSoH>', 'Read Only'))}</p>
  </div>

  <div class="permission-col col-12 col-sm-4 col-lg-3 col-xl-2 text-center text-nowrap d-flex justify-content-between d-sm-block">
    <p class="permission-headers mb-2">${until(ctx.__('<tt-J5uOoVjq>', 'Resources'))}</p>
    <p class="permission-headers text-muted">${until(ctx.__('<tt-fyxmgFEW>', 'Read Only'))}</p>
  </div>

  ${ctx.isRootAdmin === true ? html`
    <div class="permission-col col-12 col-sm-4 col-lg-3 col-xl-2 text-center text-nowrap d-flex justify-content-between d-sm-block">
      <p class="permission-headers mb-2">${until(ctx.__('<tt-twjQ5hJI>', 'Term Management'))}</p>
      <permission-check-mark .state="${ThreeWayToggle.VALUES.ALL}"></permission-check-mark>
    </div>` : nothing}

</div>
`;
